import clsx from 'clsx'

function ProductEarnPoints({ product, classWrap = 'mb-6 lg:xs-h-max:mb-2.5' }) {
  const loyaltyID = GM_STATE.product?.loyaltyID || ''

  if (GM_STATE.customer.logged || loyaltyID === '') return null

  return (
    <div className={clsx('text-xs text-neutral-700', classWrap)}>
      <div
        class="yotpo-widget-instance"
        data-yotpo-instance-id={loyaltyID}
        data-yotpo-product-id={product.id}
        data-yotpo-variant-id={product.initVariantId}
        data-yotpo-product-variants={JSON.stringify(product.variants)}
        data-yotpo-product-type={product.type}
      />
    </div>
  )
}

export default ProductEarnPoints
